import * as actionType from "../actions/actionType";

const initialState = {
  templateName: "",
  platformTemplateId: "",
  createTimeStart: "",
  createTimeEnd: "",
  page: 1,
  size: 20,
  tableList: [],
  loading: false,
  editLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.SCORE_DEPLOY_UPDATE_STATE:
      return {
        ...state,
        ...action.payload.obj,
      };
    default:
      return state;
  }
};
